import useApi from './useApi';

const useSeasonService = () => {
  const { api } = useApi();

  const getSeasons = () => api({
    method: 'get',
    url: '/product-inventory/v1/establishments/own/seasons',
  });

  const postSeason = ({ type, startDate }) => api({
    method: 'post',
    url: '/product-inventory/v1/establishments/own/seasons',
    data: {
      type,
      startDate,
    },
  });

  const putSeason = ({ seasonId, type, startDate }) => api({
    method: 'put',
    url: `/product-inventory/v1/establishments/own/seasons/${seasonId}`,
    data: {
      type,
      startDate,
    },
  });

  const deleteSeason = ({ seasonId }) => api({
    method: 'delete',
    url: `/product-inventory/v1/establishments/own/seasons/${seasonId}`,
  });

  return {
    getSeasons,
    postSeason,
    putSeason,
    deleteSeason,
  };
};

export default useSeasonService;
